import * as Msdyn365 from '@msdyn365-commerce/core';
import dayjs from 'dayjs';
import { IMFIATPInventoryEntityPLP, IMFIATPInventoryPLPResponse, IMFICartLine } from '../actions/BatchCoreProductDataServiceEntities.g';
import fetchCoreDeliveryListAction, { FetchCoreDeliveryListInput } from "../actions/fetch-core-delivery-list.action";

export interface IMFIATPInventoryEntityPLPEx extends IMFIATPInventoryEntityPLP {
    deliveryMessage: string | undefined;
}

async function getListOfCoreDeliveryMessage(ctx: Msdyn365.IActionContext, cartLines: IMFICartLine[], zipCode?: string): Promise<IMFIATPInventoryEntityPLPEx[] | undefined> {
    const data: IMFIATPInventoryPLPResponse = await fetchCoreDeliveryListAction(new FetchCoreDeliveryListInput(cartLines, zipCode), ctx);
    const updatedResponse: IMFIATPInventoryEntityPLPEx[] | undefined = data?.ATPInventoryPLPData?.map((deliveryItem: IMFIATPInventoryEntityPLP, i: number) => {
        let deliveryMessage = '';
        if (deliveryItem.Available === 'YES' && deliveryItem.ATPQuantity !== undefined && parseInt(deliveryItem.ATPQuantity, 10) > 0) {
            const date = new Date();
            const today = dayjs(Date.now()).format('D M YY');
            const deliveryDate = dayjs(deliveryItem.SlotDate).format('D M YY');
            if (today === deliveryDate) {
                deliveryMessage = `Delivery by Today ${dayjs(deliveryItem.SlotDate).format('MMM D')}`;
            } else if (deliveryDate === dayjs(date.setDate(date.getDate() + 1)).format('D M YY')) {
                deliveryMessage = `Delivery by Tomorrow ${dayjs(deliveryItem.SlotDate).format('MMM D')}`;
            } else {
                deliveryMessage = `Delivery by ${dayjs(deliveryItem.SlotDate).format('MMM D')}`;
            }
        } else {
            deliveryMessage = ctx.requestContext.app.config.defaultDeliveryMessage ? ctx.requestContext.app.config.defaultDeliveryMessage : '';
        }
        return { ...deliveryItem, deliveryMessage };
    });
    return updatedResponse;
}

export default getListOfCoreDeliveryMessage;